import React from 'react'

export const ChevronV2 = ({ open }: { open: boolean }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: !open ? 'rotate(0deg)' : 'rotate(180deg)' }}
    >
      <path
        d='M6 9L12 15L18 9'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
